<template>
  <div class="login">
    <van-form validate-first @failed="onFailed" class="login-form">
      <div class="areaBar" @click="chooseArea">
        <p>选择地区</p>
        <van-icon name="arrow" />
      </div>
      <div class="title">绍兴人大<br />“局长·代表面对面”</div>
      <!-- 通过 pattern 进行正则校验 -->
      <!-- <van-cell   ><img src="../../assets/images/user.png" alt="" /> 用户名 </van-cell > -->
      <div class="login_label">
        <!-- <img
          src="@/assets/images/user.png"
          alt=""
        /> <span ></span>
               <van-icon
          name="phone-o"
          style="font-size:16px"
        >手机号</van-icon> -->
        <van-icon name="user-o">姓名</van-icon>
      </div>
      <van-field
        v-model="login.username"
        placeholder="请输入姓名"
        name="pattern"
      />
      <!-- <br /> -->
      <div class="login_label">
        <van-icon name="phone-o">手机号</van-icon>
      </div>
      <van-field
        type="text"
        v-model="login.mobile"
        placeholder="请输入手机号"
        onPhoneChange
        @input="onPhoneChange"
        :rules="[{ phone, message: '请输入正确手机号' }]"
      >
      </van-field>
      <!-- <br /> -->
      <div class="login_label">
        <van-icon name="font-o">验证码</van-icon>
      </div>
      <van-field
        v-model="login.sms"
        center
        clearable
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button
            :loading="loading"
            size="small"
            type="primary"
            @click="handleCheck"
            :disabled="isSmsSend"
            >{{ sendBtnText }}</van-button
          >
        </template>
      </van-field>
      <div style="margin: 1.2rem">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          @click="handleLogin"
          >绑 定</van-button
        >
      </div>
    </van-form>
    <van-popup
      v-model="show"
      closeable
      :style="{ width: '100%' }"
    >
      <van-tree-select
        style="margin-top: 30px;"
        :items="items"
        :active-id.sync="activeId"
        :main-active-index.sync="activeIndex"
      />
    </van-popup>
  </div>
</template>
<script>
import request from '@/api/login'

export default {
  data () {
    return {
      isLookFlag: false,
      login: {
        username: '',
        mobile: '',
        sms: '',
        openid: null
      },
      options: [],
      props: {
        value: 'id',
        label: 'name',
        children: 'children'
      },
      pattern: /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/,
      phone: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      password: ' ',
      checked: true,
      // 是否已经发送了验证码
      isSmsSend: false,
      // 文本
      sendBtnText: '点击发送验证码',
      // 计时器对象
      timer: null,
      // 倒数60秒
      counter: 60,
      loading: false,
      code: '',
      items: [],
      activeId: 1,
      activeIndex: 0,
      show: false
    }
  },
  mounted () {
    if (process.env.NODE_ENV.includes('development')) localStorage.setItem('openid', '11112222')
    this.login.openid = localStorage.getItem('openid')
    if (!this.login.openid) {
      this.$toast.fail('系统出错，请退出重试！')
      return
    }
    const username = localStorage.getItem('username')
    // 缓存中已绑定用户名，直接到主页
    if (username !== '' && username != null) {
      this.$router.push({
        path: '/home'
      })
    }
    this.getTreeData()
  },
  methods: {
    getTreeData () {
      request.xzdqTree()
        .then((Response) => {
          this.items = Response
          this.tranItems(this.items)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    tranItems (res) {
      res.forEach(element => {
        element.text = element.name
        if (element.children) {
          this.tranItems(element.children)
        }
      })
    },
    chooseArea () {
      this.show = true
    },
    onFailed (errorInfo) {
      console.log('failed', errorInfo)
    },
    Clear () {
      this.login.password = ''
    },
    isnotLook () {
      this.isLookFlag = !this.isLookFlag
    },
    isLook () {
      this.isLookFlag = !this.isLookFlag
    },
    // 获取验证码
    async handleCheck () {
      //  之前写死
      // this.login.sms = '952700'
      // 判断手机号是否已经输入
      if (!this.login.mobile) {
        this.$notify('请输入手机号')
        return false
      }
      // 判断手机号是否符合要求
      if (this.login.mobile.length !== 11) {
        this.$notify('请输入11位手机号')
        return false
      }
      // 调用接口，发送短信验证码
      this.loading = true
      try {
        await request.getMessage(this.login.mobile)
        // 这部分放调用发送短信的接口，这里先不做任何功能，主要先把按钮倒计时的功能实现
        // 将按钮禁用，防止再次点击
        this.isSmsSend = true
        this.countDown() // 这里实现倒计时的功能
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    // 倒计时
    countDown () {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `(${this.counter}秒)后重新发送`
        this.counter--
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer)
          // 调用重置函数
          this.reset()
        }
      }, 1000)
    },
    /**
 * 重置倒计时
 */
    reset () {
      // 重置按钮可用
      this.isSmsSend = false
      // 重置文本内容
      this.sendBtnText = '点击发送验证码'
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer)
        // 重置秒数，防止下次混乱
        this.counter = 60
        // 计时器对象重置为空
        this.timer = null
      }
    },
    // 当手机号变化时，重置发送按钮
    onPhoneChange () {
      this.reset()
    },
    async handleLogin () {
      if (!this.login.username) {
        this.$toast.fail('请输入姓名')
        return false
      }
      this.$toast.loading({
        duration: 0, // 持续时间，0表示持续展示不停止
        forbidClick: true, // 是否禁止背景点击
        message: '登录中...' // 提示消息
      })
      try {
        const res = await request.GetInfo(this.login.mobile, this.login.sms)
        if (res.code === 401) {
          this.$toast.fail(res.message)
        } else {
          this.$toast.success('验证码正确')
          setTimeout(async () => {
            await request.getBd(this.login)
            this.$toast.success('绑定成功')
            // 绑定成功，缓存绑定人姓名和当前登录时间
            localStorage.setItem('username', this.login.username)
            localStorage.setItem('loginTime', new Date().getTime().toString())
            this.$router.push({
              path: '/home'
            })
          }, 1000)
        }
      } catch (error) {

      }
    }
  }

}
</script>
<style lang="less" scoped>
@bg: #1b4daa;
@cl: #1989fa;
.login {
  background-color: #fff;
  height: 100vh;
  background: url("../../assets/images/bg.png") no-repeat;
  background-size: 100% 50%;
  font-size: 0.225rem;
  color: @cl;
  .title {
    // position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 0px 20%;
    font-size: 40px;
    text-align: center;
    font-weight: bold;
    color: #3072ff;
    opacity: 0.7;
    z-index: 99;
    // text-shadow: 0rem .0625rem 0rem rgba(11, 11, 11, 0.17);
  }
  .login-form {
    padding: 30px 30px 0px 30px;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    background-color: #fff;
    text-align: center;
    border-radius: 8px;
    box-shadow: 0px 8px 15px 0px rgba(8, 19, 69, 0.09);
    .login_label {
      text-align: left;
      padding: 0rem 0.2rem;
      color: @cl;

      img {
        width: 0.1625rem;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
      }
      /deep/.van-icon {
        font-size: 30px !important;
      }
    }
    .login-tips {
      padding: 0.0875rem 0.2rem 0.25rem;
      font-size: 0.175rem;
      display: flex;
      justify-content: space-between;
      NaNpxber {
        float: left;
        color: @cl;
      }
      a {
        float: right;
        cursor: pointer;
        vertical-align: middle;
        color: @cl;
      }
    }
  }
  .login_foot {
    margin: 0.125rem auto;
    font-size: 0.15rem;
  }
}
.areaBar{
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
}
/deep/.van-field__body {
  padding: 0.0625rem !important;
  padding-top: 0rem !important;
  border-bottom: 0.0125rem solid #d8d8d8;
}

/deep/.van-checkbox__label {
  color: @cl !important;
}

/deep/.van-checkbox__icon .van-icon {
  border: 0.0125rem solid @cl !important;
}
/deep/.van-cell {
  padding: 0.0625rem 0.2rem 0.125rem !important;
}
/deep/.van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
  display: inline-block !important;
  margin-left: 0.0375rem !important;
}
</style>
